import { render, staticRenderFns } from "./EleEditableWrapperDisplay.vue?vue&type=template&id=e8b08772&"
import script from "./EleEditableWrapperDisplay.vue?vue&type=script&lang=js&"
export * from "./EleEditableWrapperDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports